import { useMemo } from "react";
import { useSelector } from "react-redux";

import SurveyViewsTable from "@/domains/survey-views/components/SurveyViewTable";
import { Roles } from "@/shared/utils/constants";
import { SurveyViewPublicationDestination } from "@/redux/survey-views/types";
import { selectCurrentUser } from "@/redux/authentication/selectors";

const SignatorySurveys = () => {
  const currentUser = useSelector(selectCurrentUser);

  const defaultFilters = useMemo(() => {
    if (currentUser) {
      const filters = {
        publicationDestination: SurveyViewPublicationDestination.IN_APP,
      };
      if (currentUser.role === Roles.ADMIN.value) {
        return filters;
      }
      return {
        ...filters,
        excludeOrganizations: currentUser.organization?.id,
      };
    }
  }, [currentUser]);

  return (
    <div className="page-layout">
      {defaultFilters && (
        <SurveyViewsTable
          columnNames={[
            "title",
            "organization",
            "dataFormat",
            "survey",
            "createdAt",
            "actions",
          ]}
          filterNames={[
            "search",
            "survey",
            "organizations",
            "chapters",
            "countries",
            "dataFormat",
          ]}
          defaultFilters={defaultFilters}
        />
      )}
    </div>
  );
};

export default SignatorySurveys;
